import { FormattedMessage } from "react-intl";

import { Text } from "@/components/atoms/Text";
import LightbulbIcon from "@/icons/__generated__/Lightbulb/Lightbulb24";

type MinHoursDurationProps = {
  minimumDuration: string;
};

export const MinHoursWarning = ({ minimumDuration }: MinHoursDurationProps) => {
  return (
    <div className="tw-flex tw-flex-col">
      <div className="tw-flex tw-gap-16">
        <LightbulbIcon className="tw-min-w-24 tw-text-yellow-600" />
        <div className="">
          <Text typeface="body-2-m" testId="minimum-duration-warning-text">
            <FormattedMessage
              defaultMessage="{minimumDuration} hr minimum"
              values={{
                minimumDuration,
              }}
            />
          </Text>
          <Text typeface="body-1-long" className="tw-text-gray-600">
            <FormattedMessage defaultMessage="The host is more likely to accept if your request meets their minimum duration." />
          </Text>
        </div>
      </div>
    </div>
  );
};
